import { Subtitle } from '@snapi/luxury';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useToggle } from 'react-use';
import { CardBadge } from '../card-badge/card-badge';
import { TextButton } from '@snapi/luxury';


interface Info {
  title: string;
  description: string;
}

export type NewDashboardCardProps = {
  title: string;
  badge: { good: boolean; status: string };
  summary: string;
  children: React.ReactNode;
  info: Info[];
};

export const NewDashboardCard: React.FC<NewDashboardCardProps> = ({
  badge,
  title,
  summary,
  children,
  info,
}) => {
  const [showInfo, toggleInfo] = useToggle(false);

  return (
    <>
      <div className="lg:hidden">
        <AnimatePresence>
          <motion.div
            className="flex shrink-0 flex-col rounded-[10px] w-[280px] h-[340px] p-3 relative bg-yellow-light text-body md:w-[336px] "
            initial={false}
            animate={showInfo ? 'info' : 'card'}
            variants={{
              info: {
                rotateY: [0, 90, 0],
                transition: { duration: 1 },
              },
              card: {
                rotateY: [0, 90, 0],
                transition: { duration: 1 },
              },
            }}
          >
            <div className="flex pb-3 relative">
              <div className="flex flex-1 items-center">
                <h5 className="uppercase">{title}</h5>
              </div>
              <CardBadge good={badge.good}>{badge.status}</CardBadge>
              <div className="absolute bottom-0 -left-3 -right-3 border-b border-gray-soft"></div>
            </div>

            <motion.div
              initial={{ display: 'flex' }}
              animate={
                showInfo
                  ? {
                      display: 'none',
                      transition: { delay: 0.5 },
                    }
                  : {
                      display: 'flex',
                      transition: { delay: 0.5, duration: 0.5 },
                    }
              }
              className="flex-1 flex-col"
            >
              <div className="flex flex-1 flex-col">{children}</div>
              <div className="flex mb-5">
                <Subtitle>{summary}</Subtitle>
              </div>
            </motion.div>
            <motion.div
              initial={{ display: 'none' }}
              animate={
                showInfo
                  ? {
                      display: 'flex',
                      transition: { delay: 0.5 },
                    }
                  : {
                      display: 'none',
                      transition: { delay: 0.5 },
                    }
              }
              className="flex-col overflow-auto mb-5"
            >
              {info.map(({ title, description }) => (
                <React.Fragment key={title}>
                  <span className="mt-5 text-[14px] font-semibold">
                    {title}
                  </span>
                  <span className="mt-2 text-[13px]">{description}</span>
                </React.Fragment>
              ))}
            </motion.div>
            <div className="relative ">
              <TextButton onClick={toggleInfo}>
                {showInfo ? 'Show Less' : 'Learn More'}
              </TextButton>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className=" shrink-0 flex-col rounded-[10px] h-[340px] p-3 relative bg-yellow-light text-body w-[464px] hidden lg:flex xl:w-[586px]">
        <div className="flex pb-3 relative">
          <div className="flex flex-1 items-center">
            <h5 className="uppercase">{title}</h5>
          </div>
          <CardBadge good={badge.good}>{badge.status}</CardBadge>
          <div className="absolute bottom-0 -left-3 -right-3 border-b border-gray-soft"></div>
        </div>
        <div className="flex">
          <div className="flex flex-col basis-1/2 justify-between pr-3 border-r border-gray-soft">
            <div className="flex flex-col">{children}</div>
            <div className="flex mb-5">
              <Subtitle>{summary}</Subtitle>
            </div>
          </div>
          <div className="flex-col basis-1/2 overflow-auto h-[296px] pt-3 px-3 xl:overflow-hidden">
            {info.map(({ title, description }) => (
              // <React.Fragment key={title}>
              //   <span className="mt-5 text-[14px] font-semibold">{title}</span>
              //   <span className="mt-2 text-[13px]">{description}</span>
              // </React.Fragment>
              <>
                <Subtitle>{title}</Subtitle>
        
                <div className='text-[10px] leading-[14px] mb-3'>{description}</div>
                  </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
